import { Button, Form } from 'antd';
import '../ViewWorkflowModal.less';
import { useContext } from 'react';
import { ContextApp } from '../../../contexts/ContextApp';

interface RejectEndsFlowBtnGroupProps {
  nextActivityData: {
    approval: string;
    decline: string;
  };
  handleStepZeroSubmit: (
    isRejectedValue: boolean,
    nextTask: string,
    finalize?: boolean,
  ) => Promise<void>;
}
const RejectEndsFlowBtnGroup = (props: RejectEndsFlowBtnGroupProps) => {
  const { nextActivityData, handleStepZeroSubmit } = props;
  const { t } = useContext(ContextApp);

  return (
    <Form.Item id="button1">
      <div className="button-container">
        <Button
          onClick={async () => {
            try {
              handleStepZeroSubmit(true, '', true);
            } catch (error) {}
          }}
          type="ghost"
        >
          {t('action.reject')} y Finalizar
        </Button>

        <Button
          type="primary"
          htmlType="button"
          onClick={async () => {
            try {
              handleStepZeroSubmit(false, nextActivityData.approval, false);
            } catch (err) {}
          }}
        >
          {t('action.aprove')}
        </Button>
      </div>
    </Form.Item>
  );
};

export default RejectEndsFlowBtnGroup;
